import { language } from "shared/language";

export const WHITE_LABEL_EXISTED = language.white_label_existed;
export const WHITE_LABEL_NOT_FOUND = language.white_label_not_found;
